module.exports = __webpack_public_path__ + "assets/07d672a98aba8ff5beaa510b9784f0f8.svg";